import React, { useState, useEffect } from 'react';
import {
  Box, Button, IconButton, Typography, TextField, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, Dialog,
  DialogTitle, DialogContent, DialogActions, MenuItem, CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import {BACKEND_BASE_URL, CAPTURE_BACKEND_URL} from '../config';


import { useLocation } from 'react-router-dom';
const ManageMeeting = () => {
  const [open, setOpen] = useState(false);
  const [municipalities, setMunicipalities] = useState([]);
  const [loadingTowns, setLoadingTowns] = useState(false);
  const [meetingType, setMeetingType] = useState('');
  // --------------------------new
  const location = useLocation();
  // ------------------------------
  const [selectedTown, setSelectedTown] = useState('');
  const [meetingTypes, setMeetingTypes] = useState([]);
  const [loadingMeetings, setLoadingMeetings] = useState(false);
 
  // New state variables for inline editing
  const [editRowId, setEditRowId] = useState(null);
  const [editedMeeting, setEditedMeeting] = useState({ name: '', town_id: '' });
 

 
  const token = localStorage.getItem("authToken");
  const authHeaders = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
 
  useEffect(() => {
    if (selectedTown) {
      fetchMeetingTypes(selectedTown);
    }
  }, [selectedTown]);
 
  const handleOpen = () => {
    setOpen(true);
    fetchTowns();
  };
 
  const handleClose = () => {
    setOpen(false);
    setMeetingType('');
  };
 
  const fetchTowns = async () => {
    setLoadingTowns(true);
    try {
      const response = await fetch(`${BACKEND_BASE_URL}/api/capture/capture-municipalities/`);
      const data = await response.json();
      setMunicipalities(data.data || []);
    } catch (error) {
      console.error('Failed to fetch towns:', error);
    } finally {
      setLoadingTowns(false);
    }
  };
 
 useEffect(() => {
    // If selectedTown is set, or if it's the initial load, fetch the meeting types.
    if (selectedTown) {
      fetchMeetingTypes(selectedTown);
    }
    // You might also want to fetch towns on initial load
    fetchTowns();
}, [selectedTown]);
 
const fetchMeetingTypes = async (town) => {
    if (!token) return;
 
    setLoadingMeetings(true);
    try {
      let url = `${BACKEND_BASE_URL}/api/capture/meeting-types/list/`;
 
      if (town && town !== "all") {
        url += `?municipality=${town}`;
      }
 
      const response = await fetch(url, {
        headers: authHeaders,
      });
 
      const data = await response.json();
      setMeetingTypes(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Error fetching meeting types:", err);
      setMeetingTypes([]);
    } finally {
      setLoadingMeetings(false);
    }
  };
  const createMeetingType = async (meetingTypeData) => {
    try {
      const response = await fetch(
        `${BACKEND_BASE_URL}/api/capture/meeting-types/create/`,
        {
          method: 'POST',
          headers: authHeaders,
          body: JSON.stringify(meetingTypeData),
        }
      );
      if (response.ok) {
        fetchMeetingTypes(selectedTown);
        handleClose();
      } else {
        console.error('Failed to create meeting type:', await response.json());
      }
    } catch (err) {
      console.error("Error creating meeting type:", err);
    }
  };
 
 const updateMeetingType = async (id, meetingTypeData) => {
    try {
      const response = await fetch(
        `${BACKEND_BASE_URL}/api/capture/meeting-types/update/${id}/`,
        {
          method: 'PUT',
          headers: authHeaders,
          body: JSON.stringify(meetingTypeData),
        }
      );
      if (response.ok) {
        // Await the fetch operation to ensure data is updated
        await fetchMeetingTypes(selectedTown);
        setEditRowId(null); // Then, exit edit mode
      }
    } catch (err) {
      console.error("Error updating meeting type:", err);
    }
  };
 
  const deleteMeetingType = async (id) => {
    try {
      const response = await fetch(
        `${BACKEND_BASE_URL}/api/capture/meeting-types/delete/${id}/`,
        {
          method: 'DELETE',
          headers: authHeaders,
        }
      );
      if (response.ok) {
        fetchMeetingTypes(selectedTown);
      }
    } catch (err) {
      console.error("Error deleting meeting type:", err);
    }
  };
 
  // New functions for managing inline editing
  const handleEditClick = (meeting) => {
    setEditRowId(meeting.id);
    setEditedMeeting({ name: meeting.name, town_id: meeting.town });
  };
 
  const handleCancelClick = () => {
    setEditRowId(null);
    setEditedMeeting({ name: '', town_id: '' });
  };
 
  const handleSaveClick = (id) => {
    const payload = {
      name: editedMeeting.name,
      town: editedMeeting.town_id,
    };
    updateMeetingType(id, payload);
  };
// =================================================================
  useEffect(() => {               // <-- Add inside component
    const params = new URLSearchParams(location.search);
    const municipalityId = params.get("municipalityId");
    if (municipalityId) {
      setSelectedTown(municipalityId);
    }
  }, [location.search]);
//  ===============================================
  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
      <Typography variant="h5" gutterBottom>Meeting Setup</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
      <TextField
          select
          label="Select Town to view meetings"
          variant="outlined"
          size="small"
          value={selectedTown}
          onChange={(e) => setSelectedTown(e.target.value)}
          sx={{ minWidth: 200 }}
        >
          {/* <MenuItem key="all" value="all">
            All
          </MenuItem> */}
          {Array.isArray(municipalities) && municipalities.map((town) => (
            <MenuItem key={town.id} value={town.id}>
              {town.name}
            </MenuItem>
          ))}
        </TextField>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpen} sx={{ ml: 2 }}>
          Create Meeting Type
        </Button>
      </Box>
      </Box>
 
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: '#1E2A78' }}>
            <TableRow>
              <TableCell sx={{ color: '#fff' }}>S.No.</TableCell>
              <TableCell sx={{ color: '#fff' }}>Town</TableCell>
              <TableCell sx={{ color: '#fff' }}>Meeting Type</TableCell>
              <TableCell sx={{ color: '#fff' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingMeetings ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : Array.isArray(meetingTypes) && meetingTypes.length > 0 ? (
              meetingTypes.map((meeting, index) => (
                <TableRow key={meeting.id}>
                  <TableCell>{index + 1}</TableCell>
                  {editRowId === meeting.id ? (
                    <>
                      <TableCell>
                        <TextField
                          select
                          size="small"
                          value={editedMeeting.town_id}
                          onChange={(e) => setEditedMeeting({ ...editedMeeting, town_id: e.target.value })}
                          fullWidth
                        >
                          {municipalities.map((town) => (
                            <MenuItem key={town.id} value={town.id}>
                              {town.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          value={editedMeeting.name}
                          onChange={(e) => setEditedMeeting({ ...editedMeeting, name: e.target.value })}
                          fullWidth
                        />
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>{meeting.town_name}</TableCell>
                      <TableCell>{meeting.name}</TableCell>
                    </>
                  )}
                  <TableCell>
                    {editRowId === meeting.id ? (
                      <>
                        <IconButton color="primary" onClick={() => handleSaveClick(meeting.id)}>
                          <SaveIcon />
                        </IconButton>
                        <IconButton color="error" onClick={handleCancelClick}>
                          <CancelIcon />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <IconButton color="primary" onClick={() => handleEditClick(meeting)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => deleteMeetingType(meeting.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No meeting types found for the selected town.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
 
      {/* Modal Dialog for creating a new meeting type */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Create New Meeting Type</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Meeting Type"
            fullWidth
            margin="normal"
            value={meetingType}
            onChange={(e) => setMeetingType(e.target.value)}
          />
          {loadingTowns ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <TextField
              select
              label="Select Town"
              fullWidth
              margin="normal"
              value={selectedTown}
              onChange={(e) => setSelectedTown(e.target.value)}
            >
              {Array.isArray(municipalities) && municipalities.map((town) => (
                <MenuItem key={town.id} value={town.id}>
                  {town.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              const payload = {
                name: meetingType,
                town: selectedTown,
              };
              createMeetingType(payload);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
 
export default ManageMeeting;
 